module.exports = __webpack_public_path__ + "img/205012858.afecb912.png";